<template>
    <div>



        <div v-bind:key="index" v-for="(criteria, index) in items" >
            <md-list>
                <md-list-item md-expand>
                    <span class="md-list-item-text">{{ criteria.title }}</span>
                    <md-list slot="md-expand">
                        <div :key="score" v-for="(description, score) in criteria.items">
                            {{ score }} <md-radio :value="score" v-model="criteria.checked">
                            <div v-html="description.description">
                                {{ description.description }}
                            </div>
                        </md-radio>
                        </div>
                    </md-list>
                </md-list-item>
            </md-list>
        </div>
        <md-button @click="submitScoring()">Submit</md-button>
    </div>
</template>

<script>
export default {
  name: "FbRubric",
  props: ["element_uuid", "mode", "validate"],
  computed: {
    messageClass() {
      return {
        "md-invalid": !this.valid && this.validate === true,
      };
    },
    valid() {
      return true;
    },
    // value() {
    //   if (this.valid) {
    //     return {
    //       uuid: this.element.uuid,
    //       items:  this.element.data.value,
    //       type: this.element.type,
    //     };
    //   }
    //   return undefined;
    // },
  },

  data() {
    return {
      items: drupalSettings.rubrics,
      coachSubmissionUuid: null,
      coachSubmission: this.getCoachSubmission(),
      user: drupalSettings.user,
    }
  },
  methods: {
    submitScoring() {
      this.$emit("validation", this.valid);
      this.setCoachSubmission();
    },

    getChecked(data) {
     for (var criteria in data) {
       let checkedLabel= data[criteria].checked;
       for (var label in data[criteria].items) {
         if (checkedLabel == label) {
           data[criteria].items[label].checked  = true;
         }
       }
     };
     return data;
   },

    getToken() {
      return fetch("/session/token?t=" + Date.now(), {
        credentials: "include"
      })
      .then(response => {
        return response.text();
      })
      .then(text => {
        return text;
      });
    },

    getCoachSubmission() {
      let self = this;
      return this.getToken().then(token => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/vnd.api+json");
        fetch_headers.append("X-CSRF-Token", token);
        fetch("/jsonapi/coach_submission/coach_submission?filter[user.id]=" + this.user.uuid + "&filter[submission_uuid]=" + this.element_uuid, {
          credentials: "include",
          method: 'GET',
          headers: fetch_headers,
        })
        .then(response => {
          return response.json();
        })
        .then(json => {
          if (json.hasOwnProperty('data')) {
            let data = json.data.shift();
            if (data.hasOwnProperty('id')) {
              self.coach_submission = data;
              self.coachSubmissionUuid = data.id;
              self.items = self.getChecked(JSON.parse(data.attributes.data.value).rubric);
            }
          }
        });
      });
    },

    setCoachSubmission() {
      return this.getToken().then(token => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/vnd.api+json");
        fetch_headers.append("X-CSRF-Token", token);
        let method = 'POST';
        if (this.coachSubmissionUuid != null) {
          method = 'PATCH';
        }
        fetch("/jsonapi/coach_submission/coach_submission" + (this.coachSubmissionUuid != null ? "/" + this.coachSubmissionUuid : ""), {
          credentials: "include",
          method: method,
          headers: fetch_headers,
          body: JSON.stringify({
            data: {
              id: this.coachSubmissionUuid,
              type: "coach_submission--coach_submission",
              attributes: {
                submission_uuid: this.element_uuid,
                data: JSON.stringify({
                  'rubric': this.items
                })
              }
            }
          })
        })
        .then(response => {
          return response.json();
        })
        .then(json => {
          this.coach_submission = '';
          this.getCoachSubmission();
        });
      });
    }


  },
  watch: {
  },
};
</script>
